import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent implements OnInit {
  @Input() color = '#5f5b68';
  @Input() size = '200px';

  constructor() {}

  ngOnInit(): void {}
}
